import React from "react";

export default function AWS_Pinpoint() {
  return (
    <div>
      <h1>What is AWS Pinpoint</h1>
      <p>
        Route: <code>/aws/pinpoint</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
